import { render, staticRenderFns } from "./TagsTable.vue?vue&type=template&id=100f134e&scoped=true&"
import script from "./TagsTable.vue?vue&type=script&lang=ts&"
export * from "./TagsTable.vue?vue&type=script&lang=ts&"
import style0 from "./TagsTable.vue?vue&type=style&index=0&id=100f134e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f134e",
  null
  
)

export default component.exports